import BaseService from './base.service';

export default class WorkspaceService extends BaseService {
  async createWorkspace(data) {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      const objectKey = key === 'logoUrl' ? 'file' : key;
      if (objectKey === 'namespaceIds') data[key].forEach((val) => formData.append('namespaceIds[]', val));
      else formData.append(objectKey, data[key]);
    });
    await this.sendFormData('POST', '/workspaces', formData);
  }

  async getWorkspaces(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/workspaces${queryString}`);
  }

  async getWorkspaceById(id) {
    return this.get(`/workspaces/${id}`);
  }

  async getCurrentWorkspace() {
    return this.get(`/workspaces/current`);
  }

  async requestClinicCode(name) {
    return this.post('/workspaces/clinic-code', { name });
  }

  async verifyClinicCode(code) {
    return this.get(`/workspaces/clinic-code/${code}`);
  }

  async updateCanRequestBeforePay(id, isAllowed) {
    return this.put(`/workspaces/${id}/request-before-pay`, {
      canRequestBeforePay: isAllowed,
    });
  }

  async updateCreatorMode(id, isActive) {
    return this.put(`/workspaces/${id}/creator-mode`, {
      creatorMode: isActive,
    });
  }

  async updateNamespaces(id, namespaceIds) {
    return this.put(`/workspaces/${id}/namespace`, {
      namespaceIds,
    });
  }

  async getWorkspaceSignature(workspaceId) {
    return this.get(`/signatures/workspace/${workspaceId}`);
  }

  async createWorkspaceSignature(workspaceId, content) {
    return this.post(`/signatures/workspace/${workspaceId}`, {
      content,
    });
  }

  async updateWorkspaceSignature(workspaceId, content) {
    return this.put(`/signatures/workspace/${workspaceId}`, {
      content,
    });
  }

  async updateDiscountId(id, discountId) {
    return this.put(`/workspaces/${id}/discount`, {
      discountId,
    });
  }

  async updateWorkspaceMainFileType(id, mainFileType) {
    return this.put(`/workspaces/${id}/main-file-type`, {
      mainFileType,
    });
  }

  async updateWorkspaceRadiologyReportRequired(id, radiologyReportRequired) {
    return this.put(`/workspaces/${id}/radiology-report-required`, {
      radiologyReportRequired,
    });
  }

  async updateWorkspaceSendPlacedOrdersToAdmins(workspaceId, sendPlacedOrdersToAdmins) {
    return this.put(`/workspaces/${workspaceId}/send-placed-orders-to-admins`, {
      sendPlacedOrdersToAdmins,
    });
  }

  async updateWorkspaceEmailsForPlacedOrders(workspaceId, emailsForPlacedOrders) {
    return this.put(`/workspaces/${workspaceId}/emails-for-placed-orders`, {
      emailsForPlacedOrders,
    });
  }

  updateWorkspace(data, workspaceId) {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      const objectKey = key === 'logoUrl' ? 'file' : key;
      formData.append(objectKey, data[key]);
    });
    return this.sendFormData('PUT', `/workspaces/${workspaceId}`, formData);
  }

  updateLandingUrl(workspaceId, landingUrl) {
    return this.put(`/workspaces/${workspaceId}/landing-url`, { landingUrl });
  }

  updateSubdomain(workspaceId, subdomain) {
    return this.put(`/workspaces/${workspaceId}/subdomain`, { subdomain });
  }

  discountDetail() {
    return this.get('/workspaces/current/discount-detail');
  }

  async getUserSignature(userId) {
    return this.get(`/signatures/user/${userId}`);
  }

  async createUserSignature(userId, content) {
    return this.post(`/signatures/user/${userId}`, { content });
  }

  async updateUserSignature(userId, content) {
    return this.put(`/signatures/user/${userId}`, { content });
  }
}
